import { isLoadingSelector, isUpdatedSelector, errorSelector } from '../utils/helperSelectors';
const reducerName = 'smsAppLink';
export const smsAppLinkSelector = (state) => state.smsAppLink.data || '';
export const isSmsAppLinkLoadingSelector = isLoadingSelector(reducerName);
export const isSmsAppLinkUpdatedSelector = isUpdatedSelector(reducerName);
export const smsAppLinkErrorSelector = errorSelector(reducerName);
//# sourceMappingURL=selector.js.map